// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconBillPayEmptyState } from '../../../../../../../assets/icons/svg/stamp-icons/ic-stamp-bill.svg';
import { BILLS_TABLE_OPTIONS } from '../../../consts';
import { AddNewBillButton } from '../../../../../components/AddNewBillButton';

interface IProps {
  tableName: string;
}

export const STYLES = {
  TITLE: 'w-full text-center font-metricR text-bw08 text-[18px] mt-[18px] mb-[3px]',
  TEXT: 'w-full text-center font-metricR text-bw07 text-[16px] mb-[18px]',
  WRAPPER: 'w-full h-[345px] border border-t-[0] rounded-b-lg border-bw03 flex',
};

const getEmptyStateTitle = (tableName: string) => {
  if (tableName === BILLS_TABLE_OPTIONS.UNPAID) return 'BILL_PAY.BILLS_HUB.EMPTY_STATE.UNPAID_TITLE';
  if (tableName === BILLS_TABLE_OPTIONS.PAID) return 'BILL_PAY.BILLS_HUB.EMPTY_STATE.PAID_TITLE';
  return '';
};

const getEmptyStateContent = (tableName: string) => {
  if (tableName === BILLS_TABLE_OPTIONS.UNPAID) return 'BILL_PAY.BILLS_HUB.EMPTY_STATE.UNPAID_CONTENT';
  if (tableName === BILLS_TABLE_OPTIONS.PAID) return 'BILL_PAY.BILLS_HUB.EMPTY_STATE.PAID_CONTENT';
  return '';
};
export const BillsTableEmptyState = ({ tableName } : IProps) => {
  const { t } = useTranslation();
  return (
    <div className={STYLES.WRAPPER}>
      <div className='flex justify-center items-center self-center flex-wrap grow'>
        <IconBillPayEmptyState />
        <h3 className={STYLES.TITLE}>{t(getEmptyStateTitle(tableName))}</h3>
        <p className={STYLES.TEXT}>{t(getEmptyStateContent(tableName))}</p>
        {tableName === BILLS_TABLE_OPTIONS.UNPAID && <AddNewBillButton testId='bill-pay__bills_empty_state__add-new-bill-button ' className='w-[200px] h-[40px] flex justify-center items-center' />}
      </div>
    </div>
  );
};
